<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'InitialState'
};
</script>
